const sceneConfigObj = {
  "defaultLevels": {
    "room": {
      "level": 0,
      "name": "room",
      "alias": "room",
      "steps": ["room"],
      "permanent": true,
      "editable": true,
      "defaultImgAlias": "environment",
      "linkedTo": ["bed"]
    },
    "bedBase": {
      "level": 1,
      "name": "bedding",
      "alias": "bedding",
      "steps": ["bedding"],
      "defaultImgAlias": "bedding",
      "permanent": false,
      "imgAlias": "bedding"
    }
  },
  "dynamicLevels": {
    "bed": {
      "visible": true,
      "level": 1,
      "name": "bed",
      "alias": "bed",
      "steps": [
        "bed", 
        "bedHeadboardFinishing",
        "bedFrame"
      ]
    },
    "pillows": {
      "lengthSelect": true,
      "visible": true,
      "level": 4,
      "name": "pillows",
      "alias": "pillows",
      "showDefault": true,
      "types": ["bed"],
      "steps": [
        "pillowSquare",
        "pillowRectangular",
        "pillowRectangularB",
        "pillowDecorative"
      ]
    },
    "bedSet": {
      "visible": true,
      "level": 3,
      "name": "bed set",
      "alias": "bedSet",
      "steps": ["bedSet"]
    },
    "duvetCover": {
      "visible": true,
      "level": 2,
      "name": "duvet cover",
      "alias": "duvetCover",
      "steps": ["duvetCover"]
    },
    "bedCover": {
      "visible": true,
      "level": 5,
      "name": "bed cover & light quilt",
      "alias": "bedCover",
      "steps": ["bedCover"]
    },
    "environment": {
      "visible": true,
      "level": 0,
      "name": "environment",
      "alias": "environment",
      "steps": ["environment"]
    }
  }
}

export default sceneConfigObj;
